import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Usuario } from '../models/usuario';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  //Url da API

  private url = `${environment.apiUrl}/usuarios`;

  constructor(private http: HttpClient) {}

  selecionar(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.url);
  }

  cadastrar(obj: Usuario): Observable<Usuario> {
    return this.http.post<Usuario>(this.url, obj);
  }

    alterar(id: number, obj: Usuario): Observable<Usuario> {
    return this.http.put<Usuario>(`${this.url}/${id}`, obj);
  }

  remover(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  // Substitui remoção por desativação (PATCH) - adiciona endpoint para ativar/desativar usuário
  desativar(id: number, ativo: boolean = false): Observable<Usuario> {
    return this.http.patch<Usuario>(`${this.url}/${id}/ativo?ativo=${ativo}`, null as any);
  }
}
